import { useEffect, useRef, useState } from "react";
import i18n from "i18next";
import BrazilIcon from '../../../Assets/images/icon/Language-Brasil.png'
import CanadaIcon from '../../../Assets/images/icon/Language-Canada.png'
import EspanhaIcon from '../../../Assets/images/icon/Language-Espanha.png'
import { useLanguage } from '../../../contexts/LanguageContext';

export function LanguageChange(props: any) {
    const { setLanguage: setContextLanguage } = useLanguage();

    async function checkSelectedLanguage() {        
        let lang = getSelectedLanguage()        
        setLanguage(lang)
        i18n.changeLanguage(lang)
    }

    // Usar getSelectedLanguage() para obter o idioma inicial
    const [Language, setLanguage] = useState(getSelectedLanguage());
    const [isOpen, setIsOpen] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 81, left: 1829 });
    const buttonRef = useRef<HTMLDivElement>(null);

    useEffect(() => {        
        checkSelectedLanguage()
    }, [])

    useEffect(() => {
        if (isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setMenuPosition({
                top: rect.bottom + 8, // 8px abaixo do botão (sem scroll pois é position: fixed)
                left: rect.left // sem scroll pois é position: fixed
            });
        }
    }, [isOpen]);

    // Fechar menu ao fazer scroll ou clicar fora
    useEffect(() => {
        const handleScroll = () => {
            if (isOpen) {
                setIsOpen(false);
            }
        };

        const handleClickOutside = (event: MouseEvent) => {
            if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            window.addEventListener('scroll', handleScroll);
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const setNewLangague = (lang: string) => {
        localStorage.setItem("language", lang)
        setLanguage(lang)
        setIsOpen(false)
        i18n.changeLanguage(lang)
        
        // Sincronizar com LanguageContext para querystring
        if (lang === 'pt-BR') {
            setContextLanguage('pt');
        } else if (lang === 'en-US') {
            setContextLanguage('en-US');
        } else if (lang === 'es') {
            setContextLanguage('es-ES');
        }
        
        props.changeLanguage && props.changeLanguage()
    }

    return <>
        <div className="m-4" style={{ position: 'relative', display: 'inline-block' }}>

            <div 
                ref={buttonRef}
                style={{paddingLeft: 8}}
                onClick={() => {
                    setIsOpen(!isOpen)
                }}
            >
                {
                    Language === 'pt-BR' ?
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <img src={BrazilIcon} style={{marginLeft: 3}} width={32} height={32}/>    
                            {typeof window !== 'undefined' && window.innerWidth <= 600 && <span style={{color: '#FFF', width: '100px', background: '#0058D0'}}>{i18n.t('language_pt')}</span>}
                        </div>
                    : Language === 'en-US' ?
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <img src={CanadaIcon} style={{marginLeft: 3}} width={32} height={32}/>    
                            {typeof window !== 'undefined' && window.innerWidth <= 600 && <span style={{color: '#FFF', width: '100px', background: '#0058D0'}}>{i18n.t('language_en')}</span>}
                        </div>
                    : Language === 'es' &&      
                        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                            <img src={EspanhaIcon} style={{marginLeft: 3}} width={32} height={32}/>    
                            {typeof window !== 'undefined' && window.innerWidth <= 600 && <span style={{color: '#FFF', width: '100px', background: '#0058D0'}}>{i18n.t('language_es')}</span>}
                        </div>
                }
            </div>
            
            <div style={{
                position: 'fixed',
                top: menuPosition.top,
                left: typeof window !== 'undefined' && window.innerWidth <= 600 ? 16 : menuPosition.left,
                right: typeof window !== 'undefined' && window.innerWidth <= 600 ? 16 : undefined,
                zIndex: 10000,
                display: "flex", 
                gap: 8, 
                marginTop: 8, 
                flexDirection: 'column', 
                borderRadius: 8, 
                padding: 8, 
                background: '#0058D0', 
                justifyContent: 'center',
                alignItems: 'center',
                opacity: !isOpen ? "0" : "1",
                visibility: !isOpen ? "hidden" : "visible",
                boxShadow: '0 8px 16px 0 rgba(0,0,0,0.25)',
                transition: 'opacity 0.2s ease, visibility 0.2s ease',
            }}>
                <div             
                    onClick={() => {setNewLangague('pt-BR')}} 
                    style={{
                        borderRadius: 32, 
                        border: Language === 'pt-BR' ? '3px solid #FFF': '3px solid #0058D0', 
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 8,
                        cursor: 'pointer',
                        transition: 'background-color 0.2s ease',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    <img src={BrazilIcon} width={32} height={32}/> {typeof window !== 'undefined' && window.innerWidth <= 600 && <span style={{color: '#FFF', width: '100px', background: '#0058D0'}}>{i18n.t('language_pt')}</span>} 
                </div>
                <div 
                    onClick={() => {setNewLangague('en-US')}}
                    style={{
                        borderRadius: 32, 
                        border: Language === 'en-US' ? '3px solid #FFF': '3px solid #0058D0', 
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 8,
                        cursor: 'pointer',
                        transition: 'background-color 0.2s ease',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    <img src={CanadaIcon} width={32} height={32}/> {typeof window !== 'undefined' && window.innerWidth <= 600 && <span style={{color: '#FFF', width: '100px', background: '#0058D0'}}>{i18n.t('language_en')}</span>} 
                </div>
                <div onClick={() => {setNewLangague('es')}} 
                    style={{ 
                        borderRadius: 32, 
                        border: Language === 'es' ? '3px solid #FFF': '3px solid #0058D0', 
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 8,
                        cursor: 'pointer',
                        transition: 'background-color 0.2s ease',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    <img src={EspanhaIcon} width={32} height={32}/> {typeof window !== 'undefined' && window.innerWidth <= 600 && <span style={{color: '#FFF', width: '100px', background: '#0058D0'}}>{i18n.t('language_es')}</span>} 
                </div>
            </div>
            
            
        </div>
    </>
}

export function getSelectedLanguage() {
    let lang = 'pt-BR'
    //let lang = 'en-US' 
    // let lang = 'es' 
    try {
        let temp = localStorage.getItem("language");
        if (temp) {
            lang = temp
        }        
    }
    catch(e) {
        console.log(e)
    }

    return lang
}